import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { MIcon } from '../../@material-extend';
import InitFromComete from './InitializationView/InitFromComete';

const InitCometeClockingModal = ({ showModal, onClose, isMobile }) => (
  <Dialog
    fullScreen={isMobile}
    scroll="paper"
    aria-labelledby="scroll-dialog-title"
    aria-describedby="scroll-dialog-description"
    open={showModal}
    onClose={onClose}
  >
    <DialogTitle>
      <Stack direction="row" sx={{ alignItems: 'center', width: '100%', mb: 2, gap: 2 }}>
        <Typography component="h2" variant="h6" sx={{ flexGrow: 1 }}>
          Code d'association
        </Typography>
        {onClose && (
          <IconButton color="primary" onClick={onClose}>
            <MIcon icon="close" />
          </IconButton>
        )}
      </Stack>
    </DialogTitle>

    <DialogContent>
      <Stack alignItems="center">
        <InitFromComete isInModal />
      </Stack>
    </DialogContent>
  </Dialog>
);

InitCometeClockingModal.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  isMobile: PropTypes.bool
};

export default InitCometeClockingModal;
